module.exports = __webpack_public_path__ + "static/images/checkmark-in-circle-black.516f226310e7308c3d5f0f5c2ad1fea8.svg";